import styled from "@emotion/styled";

// Documents container
export const DocumentsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0.7rem;

  box-shadow: 0 0 20px 4px #e3e6ec;
  border-radius: 10px;
  transition: all 200ms ease;

  &:hover {
    transform: scale(1.04);
  }
`;

export const H1 = styled.h1`
  margin-bottom: 1rem;
`;
export const FolderIcon = styled.img`
  width: 25px;
  height: 20px;
`;
export const Span = styled.span`
  margin-right: 1rem;
  font-size: 0.8rem;
`;
